import { notification } from "antd";
import {
  GET_FORM_BY_ID_REQUEST,
  GET_FORM_BY_ID_SUCCESS,
  GET_FORM_BY_ID_FAILURE,
} from "../Types";
import { apiGet } from "../../services/apiInterceptor";

export const getFormById = (formId) => {
  return async (dispatch) => {
    dispatch({ type: GET_FORM_BY_ID_REQUEST });

    try {
      // ✅ MIGRATION : API publique (pas de token requis pour ce endpoint)
      const response = await apiGet(`api/forms/${formId}`, {
        headers: {
          // Override pour ne pas inclure Authorization sur cette route publique
          Authorization: undefined,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors de la récupération du formulaire"
        );
      }

      dispatch({ type: GET_FORM_BY_ID_SUCCESS, payload: data });

      //   notification.success({
      //     message: "Formulaire récupéré avec succès",
      //   });

      return data;
    } catch (error) {
      dispatch({ type: GET_FORM_BY_ID_FAILURE, payload: error?.message });

      notification.error({
        message:
          error?.message || "Erreur lors de la récupération du formulaire",
        duration: 5,
      });
    }
  };
};
